module.exports = __webpack_public_path__ + "img/South-Georgia-and-the-South-Sandwich-Islands.dd909a75.png";